import React from "react";
import { useSelector } from "react-redux";
import Result from "./Result";
//console.log("src/components/Results.js");

function Results() {
  const calc = useSelector((state) => state.calc);
  const init = useSelector((state) => state.init);
  if (calc.sortedTypes.length === 0) {
    return (
      <section className="calc">
        {/* cart header */}
        <header>
          <h4>{init.load3}</h4>
        </header>
      </section>
    );
  }

  return (
    <section className="calc">
      <div>
        {calc.sortedTypes.map((item) => {
          return (
            <Result
              key={item.id}
              calc={item}
              lap={calc.overlap}
              width={calc.width}
            />
          );
        })}
      </div>
    </section>
  );
}

export default Results;
